export const LOAD_INCIDENTS = 'incidents/LOAD_INCIDENTS';

export const INCIDENTS_LOADING = 'incidents/INCIDENTS_LOADING';
export const DETAILS_LOADING = 'incidents/DETAILS_LOADING';
export const SET_INCIDENTS_SELECTEDYEAR = 'incidents/SET_INCIDENTS_SELECTEDYEAR';

export const SET_SELECTED_DETAIL_INCIDENT_DIRTY = 'incidents/SET_SELECTED_DETAIL_INCIDENT_DIRTY';
export const LOAD_INCIDENTDETAILS = 'incidents/LOAD_INCIDENTDETAILS';





